import React, {Component} from 'react';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';

import {Card, Image} from 'semantic-ui-react';

import './Image.css';

export default class CardImage extends Component {

    shouldComponentUpdate({
        image: {
            url,
            width,
            height
        }
    }) {
        return url !== this.props.image.url || width !== this.props.image.width || height !== this.props.image.height;
    }

    render() {
        const {
                href,
                image: {
                    url,
                    width,
                    height
                },
                ratio
            } = this.props,
            paddingTop = ratio
                ? 100 / ratio
                : width && height && 100 / (width / height),
            style = {
                paddingTop: paddingTop
                    ? `${paddingTop}%`
                    : ""
            };
        return <Card
            as={href
                ? 'a'
                : 'div'}
            href={href}
            target="_blank"
            className="CardImage"
            fluid={true}
            style={style}>
            <LazyLoad unmountIfInvisible={true} offset={320} throttle={true}>
                <Image className="CardImage-image" src={url} width={width} height={height}/>
            </LazyLoad>
        </Card>;
    }
}

CardImage.propTypes = {
    href: PropTypes.string,
    image: PropTypes
        .shape(
            {url: PropTypes.string.isRequired, width: PropTypes.number, height: PropTypes.number}
        )
        .isRequired,
    ratio: PropTypes.number
};


// WEBPACK FOOTER //
// ./src/components/card/Image.js